function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item)
}

function mergeDeep(target, ...sources) {
  if (!sources.length) return target
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key of Object.keys(source)) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} })
        mergeDeep(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }

  return mergeDeep(target, ...sources)
}

const isProduction = process.env.NODE_ENV === 'production'
const isStaging = process.env.NODE_ENV === 'staging'

const config = {
  client: {
    ssl: false,
    domain: 'localhost:8082',
    getUrl() {
      return `${this.ssl ? 'https://' : 'http://'}${this.domain}`
    }
  },
  api: {
    ssl: false,
    domain: 'localhost:8080',
    getUrl() {
      return `${this.ssl ? 'https://' : 'http://'}${this.domain}`
    }
  },
  ws: {
    domain: 'localhost:8080',
    getUrl() {
      return `${this.ssl ? 'wss://' : 'ws://'}${this.domain}`
    }
  }
}

const productionConfig = {
  client: {
    ssl: true,
    domain: 'appcode.cmdr-ops.com'
  },
  api: {
    ssl: true,
    domain: 'api.appcode.cmdr-ops.com'
  },
  ws: {
    domain: 'ws.appcode.cmdr-ops.com'
  }
}

const stagingConfig = {
  client: {
    ssl: true,
    domain: 'dev.appcode.cmdr-ops.com'
  },
  api: {
    ssl: true,
    domain: 'dev.api.appcode.cmdr-ops.com'
  },
  ws: {
    ssl: true,
    domain: 'dev.appcode.cmdr-ops.com'
  }
}

let combinedConfig = config
if (isProduction) combinedConfig = mergeDeep(config, productionConfig)
if (isStaging) combinedConfig = mergeDeep(config, stagingConfig)

export default combinedConfig
